/* sg-pdp-zoom: lupa al pasar el cursor (escritorio) y visor a pantalla completa con pellizco/rueda/doble toque (móvil y escritorio). */
(() => {
  /* Los valores reales llegan del editor de tema por data-* del recuadro; estos solo son el respaldo (= defaults del schema). */
  const DEFAULTS = { level: 2.6, max: 5, tap: 2.5, offset: 100 };
  const SWIPE_PX = 60; // desliz mínimo para cambiar de foto
  const MOVE_PX = 6; // desplazamiento a partir del cual un toque deja de ser "toque"
  const DOUBLE_TAP_MS = 300;
  const num = (v, d) => { const n = parseFloat(v); return Number.isFinite(n) ? n : d; };
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');

  const init = (stage) => {
    if (!stage || stage.dataset.sgZoomReady) return;
    stage.dataset.sgZoomReady = '1';
    if (!stage.dataset.zoom) return;
    const HOVER_SCALE = num(stage.dataset.zoomLevel, DEFAULTS.level);
    const MAX_SCALE = num(stage.dataset.zoomMax, DEFAULTS.max);
    const TAP_SCALE = num(stage.dataset.zoomTap, DEFAULTS.tap);
    const LENS_OFFSET = Math.min(100, Math.max(0, num(stage.dataset.lensOffset, DEFAULTS.offset)));
    const hoverOn = stage.dataset.zoomHover !== 'false';
    const dialog = stage.querySelector('[data-sg-lightbox]');
    const openBtn = stage.querySelector('[data-sg-zoom-open]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    const slides = () => [...stage.querySelectorAll('.sg-pdp__slide')].filter((s) => !s.hidden);
    const activeSlide = () => stage.querySelector('.sg-pdp__slide.is-on');
    const bigSrc = (slide) => (slide && (slide.dataset.zoomSrc || (slide.querySelector('img') || {}).src)) || '';
    const overControls = (el) => el && el.closest && el.closest('.sg-pdp__tools, .sg-pdp__zoom-btn, .sg-pdp__dims, .sg-lb');
    const dimsOn = () => !!stage.querySelector('[data-sg-dims]:not([hidden])');

    /* ---------- Lupa que sigue al cursor (solo dentro del círculo hay zoom) ---------- */
    const lens = document.createElement('span'); // span: el tema oculta cualquier div vacío (div:empty)
    lens.className = 'sg-pdp__lens';
    lens.setAttribute('aria-hidden', 'true');
    stage.appendChild(lens);
    let hovering = false;
    const resetHover = () => {
      hovering = false;
      stage.classList.remove('is-zooming');
      lens.classList.remove('is-on');
    };
    const preloaded = new Set();
    const preload = (src) => {
      if (!src || preloaded.has(src)) return;
      preloaded.add(src);
      const pre = new Image();
      pre.src = src;
    };
    /* Rectángulo real que ocupa la foto dentro del recuadro (respeta cover/contain) */
    const fitRect = (im, sw, sh) => {
      const iw = im.naturalWidth || sw;
      const ih = im.naturalHeight || sh;
      const contain = getComputedStyle(im).objectFit === 'contain';
      const k = contain ? Math.min(sw / iw, sh / ih) : Math.max(sw / iw, sh / ih);
      const w = iw * k;
      const h = ih * k;
      return { w, h, x: (sw - w) / 2, y: (sh - h) / 2 };
    };
    stage.addEventListener('pointermove', (e) => {
      if (!hoverOn || e.pointerType !== 'mouse' || !fine.matches) return;
      if (overControls(e.target) || dimsOn()) { if (hovering) resetHover(); return; }
      const slide = activeSlide();
      const im = slide && slide.querySelector('img');
      if (!im) return;
      const src = slide.dataset.zoomSrc || im.currentSrc || im.src;
      if (!hovering) {
        hovering = true;
        stage.classList.add('is-zooming');
        preload(src);
        lens.classList.add('is-on');
      }
      if (lens.dataset.src !== src) {
        lens.dataset.src = src;
        const small = im.currentSrc || im.src;
        lens.style.backgroundImage = small && small !== src ? `url("${src}"), url("${small}")` : `url("${src}")`;
      }
      const r = stage.getBoundingClientRect();
      const cx = e.clientX - r.left;
      const cy = e.clientY - r.top;
      const f = fitRect(im, r.width, r.height);
      const z = HOVER_SCALE;
      const lw = lens.offsetWidth;
      const lh = lens.offsetHeight;
      /* El cursor queda en el borde del círculo (arriba-izquierda de él); cerca de las orillas de la foto la
         separación baja a 0 para poder llegar a todos los puntos. El contenido es lo que hay bajo el centro de la lupa. */
      const gap = ((lw / 2) * LENS_OFFSET) / 100 / Math.SQRT2;
      const edge = (p, max) => { const t = Math.min(1, Math.max(0, p / max)); return 4 * t * (1 - t); };
      const lx = cx - gap * edge(cx, r.width);
      const ly = cy - gap * edge(cy, r.height);
      const u = (lx - f.x) / f.w;
      const v = (ly - f.y) / f.h;
      lens.style.transform = `translate(${lx - lw / 2}px, ${ly - lh / 2}px)`;
      lens.style.backgroundSize = `${f.w * z}px ${f.h * z}px`;
      lens.style.backgroundPosition = `${lw / 2 - u * f.w * z}px ${lh / 2 - v * f.h * z}px`;
    });
    stage.addEventListener('pointerleave', resetHover);

    /* ---------- Visor ---------- */
    const view = dialog.querySelector('[data-sg-lb-view]');
    const img = dialog.querySelector('[data-sg-lb-img]');
    const counter = dialog.querySelector('[data-sg-lb-count]');
    const prev = dialog.querySelector('[data-sg-lb-prev]');
    const next = dialog.querySelector('[data-sg-lb-next]');
    const closeBtn = dialog.querySelector('[data-sg-lb-close]');
    const skuWrap = dialog.querySelector('[data-sg-lb-sku-wrap]');
    const skuOut = dialog.querySelector('[data-sg-lb-sku]');
    const syncSku = () => {
      if (!skuWrap || !skuOut) return;
      const src = (stage.closest('sg-pdp') || document).querySelector('.sg-pdp__sku [data-sg-sku]');
      const text = src ? src.textContent.trim() : '';
      skuOut.textContent = text;
      skuWrap.hidden = !text;
    };
    let list = [];
    let idx = 0;
    let s = 1;
    let tx = 0;
    let ty = 0;

    const clamp = () => {
      const mx = Math.max(0, (img.clientWidth * s - view.clientWidth) / 2);
      const my = Math.max(0, (img.clientHeight * s - view.clientHeight) / 2);
      tx = Math.min(mx, Math.max(-mx, tx));
      ty = Math.min(my, Math.max(-my, ty));
    };
    const paint = () => {
      clamp();
      img.style.transform = `translate(${tx}px, ${ty}px) scale(${s})`;
      view.classList.toggle('is-zoomed', s > 1.01);
    };
    const reset = () => { s = 1; tx = 0; ty = 0; paint(); };
    const zoomAt = (ns, cx, cy) => {
      ns = Math.min(MAX_SCALE, Math.max(1, ns));
      const r = view.getBoundingClientRect();
      const px = cx - (r.left + r.width / 2);
      const py = cy - (r.top + r.height / 2);
      tx = px - ((px - tx) / s) * ns;
      ty = py - ((py - ty) / s) * ns;
      s = ns;
      paint();
    };
    const show = (i) => {
      if (!list.length) return;
      idx = (i + list.length) % list.length;
      const slide = list[idx];
      const own = slide.querySelector('img');
      const small = own ? own.currentSrc || own.src : '';
      const big = bigSrc(slide);
      img.src = small || big;
      img.alt = own ? own.alt : '';
      if (big && big !== small) {
        const pre = new Image();
        pre.onload = () => { if (list[idx] === slide) img.src = big; };
        pre.src = big;
      }
      if (counter) counter.textContent = `${idx + 1} / ${list.length}`;
      const multi = list.length > 1;
      [prev, next, counter].forEach((el) => { if (el) el.hidden = !multi; });
      reset();
    };
    const open = () => {
      resetHover();
      list = slides();
      const cur = list.indexOf(activeSlide());
      syncSku();
      dialog.showModal();
      document.documentElement.classList.add('sg-lb-open');
      show(cur < 0 ? 0 : cur);
    };
    dialog.addEventListener('close', () => document.documentElement.classList.remove('sg-lb-open'));
    if (openBtn) openBtn.addEventListener('click', (e) => { e.stopPropagation(); open(); });
    stage.addEventListener('click', (e) => { if (!overControls(e.target)) open(); });
    if (closeBtn) closeBtn.addEventListener('click', () => dialog.close());

    /* La foto del visor queda libre: clic derecho (o mantener presionado en el celular) ofrece copiar/guardar del navegador. */
    if (prev) prev.addEventListener('click', () => show(idx - 1));
    if (next) next.addEventListener('click', () => show(idx + 1));
    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });

    /* Gestos: arrastrar, pellizcar, doble toque/clic y rueda */
    const pts = new Map();
    let startDist = 0;
    let startScale = 1;
    let startX = 0;
    let moved = false;
    let lastTap = 0;
    const dist = () => { const [a, b] = [...pts.values()]; return Math.hypot(a.x - b.x, a.y - b.y); };
    const mid = () => { const [a, b] = [...pts.values()]; return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }; };

    view.addEventListener('pointerdown', (e) => {
      if (e.button !== 0) return; // clic derecho: deja que el navegador muestre su menú
      view.setPointerCapture(e.pointerId);
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      moved = false;
      startX = e.clientX;
      if (pts.size === 2) { startDist = dist(); startScale = s; }
    });
    view.addEventListener('pointermove', (e) => {
      const p = pts.get(e.pointerId);
      if (!p) return;
      const dx = e.clientX - p.x;
      const dy = e.clientY - p.y;
      p.x = e.clientX;
      p.y = e.clientY;
      if (Math.abs(e.clientX - startX) > MOVE_PX) moved = true;
      if (pts.size === 2) {
        const m = mid();
        zoomAt(startScale * (dist() / startDist), m.x, m.y);
      } else if (s > 1.01) {
        tx += dx;
        ty += dy;
        paint();
      }
    });
    const endPointer = (e) => {
      const had = pts.has(e.pointerId);
      pts.delete(e.pointerId);
      if (!had || pts.size) return;
      const dx = e.clientX - startX;
      if (s <= 1.01 && Math.abs(dx) > SWIPE_PX && list.length > 1) { show(idx + (dx < 0 ? 1 : -1)); return; }
      if (moved) return;
      const now = Date.now();
      if (now - lastTap < DOUBLE_TAP_MS) {
        if (s > 1.01) reset(); else zoomAt(TAP_SCALE, e.clientX, e.clientY);
        lastTap = 0;
        return;
      }
      lastTap = now;
      if (s <= 1.01 && e.target === view) setTimeout(() => { if (lastTap === now) dialog.close(); }, DOUBLE_TAP_MS + 20);
    };
    view.addEventListener('pointerup', endPointer);
    view.addEventListener('pointercancel', (e) => pts.delete(e.pointerId));
    view.addEventListener('wheel', (e) => {
      e.preventDefault();
      zoomAt(s * (e.deltaY < 0 ? 1.2 : 1 / 1.2), e.clientX, e.clientY);
    }, { passive: false });
    window.addEventListener('resize', () => { if (dialog.open) paint(); });
  };

  const boot = () => document.querySelectorAll('[data-sg-stage]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
